export const getWatanaBatchStatus = (status?: string, label?: string) => {
  const map = {
    "0": { label: "Pendiente", color: "default", variant: "outlined" },
    "1": { label: "Procesando", color: "warning", variant: "filled" },
    "2": { label: "Completado", color: "success", variant: "filled" },
    "3": { label: "Error", color: "error", variant: "filled" },
    "4": { label: "Cancelado", color: "default", variant: "outlined" },
  } as const;

  const fallback = {
    label: label || status || "Desconocido",
    color: "default" as const,
    variant: "outlined" as const,
  };

  const mapped = map[status as keyof typeof map];
  return mapped ? { ...mapped, label: label || mapped.label } : fallback;
};
